module.exports = __webpack_public_path__ + "static/img/p1.81208c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/p1.png
// module id = wnty
// module chunks = 1